export enum AIChatType {
  Keyboard,
  Recorder,
  Recording,
  Media
}
